module.exports = __webpack_public_path__ + "static/img/loading.a08657b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 4